import { render, staticRenderFns } from "./profile-info.vue?vue&type=template&id=4c75273e&scoped=true"
import script from "./profile-info.vue?vue&type=script&lang=js"
export * from "./profile-info.vue?vue&type=script&lang=js"
import style0 from "./profile-info.vue?vue&type=style&index=0&id=4c75273e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c75273e",
  null
  
)

export default component.exports